import Vue from "vue";
export default {
  GET_ALL(state, payload) {
    state.getAllBanner = payload;
  },
  SELECTED_BANNER(state, payload) {
    state.selectedBanner = payload;
  },
};
